import { ChangeEmailSuccess } from "components/changeEmail/ChangeEmailSuccess/ChangeEmailSuccess";
import { AuthenticatedApp } from "components/common/AuthenticatedApp/AuthenticatedApp";
import { Bootstrap } from "components/common/Bootstrap/Bootstrap";
import { ErrorBoundary } from "components/common/ErrorBoundary/ErrorBoundary";
import { ScrollToTop } from "components/common/ScrollToTop/ScrollToTop";
import { AccountDeleted } from "components/deleteAccount/AccountDeleted/AccountDeleted";
import { CustomBrowserRouter } from "components/_hooks/useRouter";
import { indexReducer } from "indexReducer";
import { indexSaga } from "indexSaga";
import "polyfills/Array.prototype.find";
import "polyfills/Array.prototype.includes";
import "polyfills/Intl.dumbPluralRules";
import "polyfills/Math.trunc";
import "polyfills/Object.assign";
import "polyfills/String.prototype.includes";
import "promise-polyfill/src/polyfill";
import React from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { routes } from "routes";
import { NewRelicErrorHandler } from "services/errorService";
import "webcrypto-shim";
import "whatwg-fetch";

//window.newrelic will be null if blocked by an addblocker
window && window.newrelic && window.newrelic.setErrorHandler(NewRelicErrorHandler);

const sagasMiddleware = createSagaMiddleware();
const composeEnhancer =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;
const store = createStore(indexReducer, composeEnhancer(applyMiddleware(sagasMiddleware)));

sagasMiddleware.run(indexSaga);

export const App = () => {
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <CustomBrowserRouter>
          <ScrollToTop>
            <Bootstrap>
              <Switch>
                <Route path={routes.accountDeleted} component={AccountDeleted} />
                <Route path={routes.changeEmailSuccess} component={ChangeEmailSuccess} />
                <Route component={AuthenticatedApp} />
              </Switch>
            </Bootstrap>
          </ScrollToTop>
        </CustomBrowserRouter>
      </ErrorBoundary>
    </Provider>
  );
};
export default App;
